<script setup lang="ts">
import { useDefaultStore } from "@/store";

definePage({
	name: "AdminPanel",
	redirect: "/admin-panel/categories",
});

const store = useDefaultStore();

onMounted(async () => {
	// await store.getCategories();
	await store.getGeoscopes();
	await store.getEntities();
});
</script>

<template>
	<Toast />
	<ConfirmDialog />
	<admin-header />
	<admin-sidebar />
	<main class="admin-panel-content-wrapper">
		<router-view />
	</main>
</template>
